/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cta_TitleInputs */

const en_pc_cta_title = /** @type {(inputs: Pc_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get PdfCraft and keep your money.`)
};

const zh_pc_cta_title = /** @type {(inputs: Pc_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`获取 PdfCraft，省下订阅费。`)
};

/**
* | output |
* | --- |
* | "Get PdfCraft and keep your money." |
*
* @param {Pc_Cta_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cta_title = /** @type {((inputs?: Pc_Cta_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cta_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cta_title(inputs)
	return zh_pc_cta_title(inputs)
});
export { pc_cta_title as "pc.cta.title" }